import { cn } from "cn"

export function Loading({
  size = 5,
  className,
  ...props
}: {
  size?: number | string
  className?: string
}) {
  return (
    <span
      className={cn("flex items-center gap-[1em]", className)}
      style={{ fontSize: size }}
      {...props}
    >
      <span className="size-[1em] animate-dots rounded-full bg-current" />
      <span className="size-[1em] animate-dots rounded-full bg-current delay-200" />
      <span className="size-[1em] animate-dots rounded-full bg-current delay-400" />
    </span>
  )
}
